import { render, staticRenderFns } from "./InformacoesLgpd.vue?vue&type=template&id=857685ca&scoped=true&"
import script from "./InformacoesLgpd.vue?vue&type=script&lang=js&"
export * from "./InformacoesLgpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857685ca",
  null
  
)

export default component.exports